// storybook-check-ignore
import { useState } from 'react';
import { useExperimentationContext } from 'sellDirect/ExperimentationContext';
import { AppointmentDateCard } from 'sellDirect/components/legacy/sellerDash/exteriorAssessment/AppointmentDateCard';
import { SchedulingModal } from 'sellDirect/components/legacy/sellerDash/exteriorAssessment/SchedulingModal';
import { SchedulingModalWithDateTime } from 'sellDirect/components/legacy/sellerDash/exteriorAssessment/SchedulingModalWithDateTime';

/** TODO: Add documentation */
export const ExteriorAssessmentScheduleContent: React.FC = () => {
  const {
    assertions: { isInPersonSseaEnabled },
  } = useExperimentationContext();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const changeDateTime = () => {
    setIsOpen(true);
  };

  return (
    <>
      <AppointmentDateCard data-testid="ea-earliest-availability" onChange={changeDateTime} />
      {isInPersonSseaEnabled ? (
        <SchedulingModalWithDateTime setIsOpen={setIsOpen} isOpen={isOpen} />
      ) : (
        <SchedulingModal setIsOpen={setIsOpen} isOpen={isOpen} />
      )}
    </>
  );
};
